import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import VanillaTilt from 'vanilla-tilt';
import { HomeStepperComponent } from '../home-stepper/home-stepper.component';
import { Router } from '@angular/router';
import { HomeTestimonialsComponent } from '../home-testimonials/home-testimonials.component';
import { HomePricingComponent } from '../home-pricing/home-pricing.component';
import { HomeFaqComponent } from '../home-faq/home-faq.component';
import { HomeBottomLinksComponent } from '../home-bottom-links/home-bottom-links.component';
import { ToastModule } from 'primeng/toast';
import { HomeCurrentStatsComponent } from '../home-current-stats/home-current-stats.component';

@Component({
  selector: 'app-home-header-preview',
  standalone: true,
  imports: [
    ButtonModule,
    HomeStepperComponent,
    HomeTestimonialsComponent,
    HomePricingComponent,
    HomeFaqComponent,
    HomeBottomLinksComponent,
    ToastModule,
    HomeCurrentStatsComponent
  ],
  templateUrl: './home-header-preview.component.html',
  styleUrl: './home-header-preview.component.scss'
})
export class HomeHeaderPreviewComponent implements AfterViewInit {
  @ViewChild('previewImage') previewImage: ElementRef<HTMLDivElement>;

  constructor(private router: Router) { }

  ngAfterViewInit(): void {
    VanillaTilt.init(this.previewImage.nativeElement)
  }

  openDemo() {
    this.router.navigate(['demo', 'village' ])
  }
}
